import React, { useState, useEffect } from 'react';
import { history, useIntl } from 'umi';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import MobileGames from './MobileGames';
import ConsoleGames from './ConsoleGames';
import AnnualReport from './TotalGames';
import PCGames from './PCGames';
import { GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES } from '@intelligence/components/UserGuide/GenreMarketProfile';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import '@/pages/intelligence/assets/scss/GenreProfile/index.scss';
const { Body, Content } = Layout;

const GenreProfile = () => {
  const { formatMessage } = useIntl();

  const [activeId, setActiveId] = useState('');

  const onActive = (tab: { id: any }) => {
    setActiveId(tab.id);
    history.replace(`/intelligence/genreProfile/${tab.id}`);
  };

  useEffect(() => {
    const { pathname } = history.location;
    const _activeTabId = pathname.slice(pathname.lastIndexOf('/') + 1);
    setActiveId(_activeTabId === 'genreProfile' ? 'mobileGames' : _activeTabId);
  }, []);

  const tabs = [
    {
      id: 'mobileGames',
      label: formatMessage({ id: 'dbi_mobile_games' }),
      component: <MobileGames />,
    },
    {
      id: 'pcGames',
      label: formatMessage({ id: 'dbi_pc_games' }),
      component: <PCGames />,
      className: GENRE_MARKET_PROFILE_GUIDE_CLASSNAMES.ELEMENT1_HIGHLIGHT2,
    },
    {
      id: 'consoleGames',
      label: formatMessage({ id: 'dbi_console_games' }),
      component: <ConsoleGames />,
    },
    {
      id: 'totalGames',
      label: formatMessage({ id: 'dbi_total_games' }),
      component: <AnnualReport />,
    },
  ];

  return (
    <Layout className="dbi-genre-profile">
      <Body>
        <Content>
          <Content.Header className="contentHead-normal" title={formatMessage({ id: 'dbi_genre_profile' })}>
            <div className="header-tab">
              <Tabs
                ceiling
                newMarkIdsMappingKey="GenreProfile"
                tabs={tabs}
                animated={false}
                activeId={activeId}
                onActive={onActive}
              />
            </div>
          </Content.Header>
          <Content.Body full>
            <MarqueeBanner />
            {tabs.map((e) => {
              return <div key={e.id}>{e.id == activeId ? e.component : ''}</div>;
            })}
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};

export default GenreProfile;
